export default "__VITE_ASSET__B4TKscO2__"